export enum AcademicPeriods {
    Whole_Year = 1,
    Semesterised = 2,
}